import React from 'react';

import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';

import {PaymentApplePayPrimerOneStep} from './paymentApplePayPrimer/paymentApplePayPrimerOneStep';
import {PaymentGooglePayPrimerOneStep} from './paymentGooglePayPrimer/paymentGooglePayPrimerOneStep';
import {PaymentKlarnaPrimerOneStep} from './paymentKlarnaPrimer/paymentKlarnaPrimerOneStep';
import {PaymentPaypalPrimerOneStep} from './paymentPaypalPrimer/paymentPaypalPrimerOneStep';
import {PaymentPrimerCreditCardOneStep} from './paymentPrimerCreditCard/paymentPrimerCreditCardOneStep';

export const PAYMENTS_COMPONENTS: {[key in PAYMENTS]?: React.ReactElement} = {
    [PAYMENTS.METHOD_PRIMER]: <PaymentPrimerCreditCardOneStep />,
    [PAYMENTS.METHOD_PRIMER_APPLE_PAY]: <PaymentApplePayPrimerOneStep />,
    [PAYMENTS.METHOD_PRIMER_GOOGLE_PAY]: <PaymentGooglePayPrimerOneStep />,
    [PAYMENTS.METHOD_PRIMER_KLARNA]: <PaymentKlarnaPrimerOneStep />,
    [PAYMENTS.METHOD_PRIMER_PAYPAL]: <PaymentPaypalPrimerOneStep />,
};
